export default "__VITE_ASSET__CQIa1crv__"